var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchInMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.537,
    height: 28.537,
    viewBox: "0 0 28.537 28.537",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15611",
    "data-name": "Group 15611",
    transform: "translate(16.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15610",
    "data-name": "Group 15610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7948",
    "data-name": "Path 7948",
    d: "M294.242,0A6.249,6.249,0,0,0,288,6.242c0,3.2,5.008,8.877,5.579,9.514a.891.891,0,0,0,1.327,0c.571-.637,5.579-6.31,5.579-9.514A6.249,6.249,0,0,0,294.242,0Zm0,8.918a2.675,2.675,0,1,1,2.675-2.675A2.676,2.676,0,0,1,294.242,8.918Z",
    transform: "translate(-288)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15613",
    "data-name": "Group 15613",
    transform: "translate(0 7.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15612",
    "data-name": "Group 15612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7949",
    "data-name": "Path 7949",
    d: "M.56,131.342a.894.894,0,0,0-.56.829v16.339a.891.891,0,0,0,1.224.828l7.694-3.078V128Z",
    transform: "translate(0 -128)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15615",
    "data-name": "Group 15615",
    transform: "translate(19.619 11.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15614",
    "data-name": "Group 15614"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7950",
    "data-name": "Path 7950",
    d: "M356.666,207.643a2.674,2.674,0,0,1-3.981,0c-.182-.2-.416-.467-.685-.783v12.373l8.358-3.342a.889.889,0,0,0,.56-.828V201.952A38.747,38.747,0,0,1,356.666,207.643Z",
    transform: "translate(-352 -201.952)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15617",
    "data-name": "Group 15617",
    transform: "translate(10.701 7.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15616",
    "data-name": "Group 15616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7951",
    "data-name": "Path 7951",
    d: "M196.129,129.652,192,128v18.26l7.134,2.854V134.792A23.22,23.22,0,0,1,196.129,129.652Z",
    transform: "translate(-192 -128)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchInMap);
export default __webpack_public_path__ + "static/media/search-in-map.f9cd6872ff2ac14d515a949799e1d5a3.svg";
export { ForwardRef as ReactComponent };